'use client'

import { usePathname } from 'next/navigation'
import React, { useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil'

import { loginUserState } from '@/components/Context/JwtTokenProvider'
import ContentModel from '@/components/LandingPage/ContentModel'
import { useEvent } from '@/components/hooks/useRecordEvent'
import { getFrame } from '@/serverActions/getFrame'
import { ContentModelType } from '@/types/ContentModel/ContentModel'

export default function Frame({ value }: { value: string }) {
  const pathname = usePathname()
  const { record } = useEvent()
  const loginUser = useRecoilValue(loginUserState)
  const [contentModel, setContentModel] = useState<ContentModelType | null>(null)

  useEffect(() => {
    if (contentModel == null) {
      getFrame({ value }).then((frame) => {
        if (frame != null) {
          setContentModel(frame.contentModel)
          record('view_component', { frameContentId: frame.frameContentId })
        }
      })
    }
  }, [value, loginUser, pathname])

  if (contentModel == null) {
    return <></>
  }

  return (
    <>
      <ContentModel contentModel={contentModel} />
    </>
  )
}
